/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddDraftTableRowDto } from '../models';
// @ts-ignore
import type { CreateSubmissionDto } from '../models';
// @ts-ignore
import type { CreateUpdateDraftDataDto } from '../models';
// @ts-ignore
import type { CreateUpdateDraftNoteDto } from '../models';
// @ts-ignore
import type { DeleteDraftTableRowDto } from '../models';
// @ts-ignore
import type { DraftDataDto } from '../models';
// @ts-ignore
import type { DraftNoteDto } from '../models';
// @ts-ignore
import type { FormSubmissionDto } from '../models';
// @ts-ignore
import type { QuestionSubmissionDto } from '../models';
// @ts-ignore
import type { UpdateCalculationStatusDto } from '../models';
/**
 * SubmissionsApi - axios parameter creator
 * @export
 */
export const SubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddDraftTableRowDto} addDraftTableRowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerAddDraftTableRow: async (addDraftTableRowDto: AddDraftTableRowDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addDraftTableRowDto' is not null or undefined
            assertParamExists('submissionsControllerAddDraftTableRow', 'addDraftTableRowDto', addDraftTableRowDto)
            const localVarPath = `/api/submissions/table/add-row`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDraftTableRowDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {CreateSubmissionDto} createSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateSubmission: async (formId: string, createSubmissionDto: CreateSubmissionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('submissionsControllerCreateSubmission', 'formId', formId)
            // verify required parameter 'createSubmissionDto' is not null or undefined
            assertParamExists('submissionsControllerCreateSubmission', 'createSubmissionDto', createSubmissionDto)
            const localVarPath = `/api/submissions/{formId}/submission`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUpdateDraftDataDto} createUpdateDraftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateUpdateDraftData: async (createUpdateDraftDataDto: CreateUpdateDraftDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUpdateDraftDataDto' is not null or undefined
            assertParamExists('submissionsControllerCreateUpdateDraftData', 'createUpdateDraftDataDto', createUpdateDraftDataDto)
            const localVarPath = `/api/submissions/draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpdateDraftDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUpdateDraftNoteDto} createUpdateDraftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateUpdateDraftNote: async (createUpdateDraftNoteDto: CreateUpdateDraftNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUpdateDraftNoteDto' is not null or undefined
            assertParamExists('submissionsControllerCreateUpdateDraftNote', 'createUpdateDraftNoteDto', createUpdateDraftNoteDto)
            const localVarPath = `/api/submissions/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpdateDraftNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DraftDataDto} draftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerDeleteDraftData: async (draftDataDto: DraftDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftDataDto' is not null or undefined
            assertParamExists('submissionsControllerDeleteDraftData', 'draftDataDto', draftDataDto)
            const localVarPath = `/api/submissions/draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(draftDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteDraftTableRowDto} deleteDraftTableRowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerDeleteDraftTableRow: async (deleteDraftTableRowDto: DeleteDraftTableRowDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteDraftTableRowDto' is not null or undefined
            assertParamExists('submissionsControllerDeleteDraftTableRow', 'deleteDraftTableRowDto', deleteDraftTableRowDto)
            const localVarPath = `/api/submissions/table/delete-row`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDraftTableRowDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormDraftData: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('submissionsControllerGetFormDraftData', 'formId', formId)
            const localVarPath = `/api/submissions/{formId}/draft`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormDraftDataByQuestion: async (formId: string, questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('submissionsControllerGetFormDraftDataByQuestion', 'formId', formId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('submissionsControllerGetFormDraftDataByQuestion', 'questionId', questionId)
            const localVarPath = `/api/submissions/{formId}/draft/{questionId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormDraftNote: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('submissionsControllerGetFormDraftNote', 'formId', formId)
            const localVarPath = `/api/submissions/{formId}/note`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormSectionSubmission: async (formId: string, sectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('submissionsControllerGetFormSectionSubmission', 'formId', formId)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('submissionsControllerGetFormSectionSubmission', 'sectionId', sectionId)
            const localVarPath = `/api/submissions/{formId}/{sectionId}/submission`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetPreviousSubmissions: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('submissionsControllerGetPreviousSubmissions', 'formId', formId)
            const localVarPath = `/api/submissions/{formId}/previous-submissions`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCalculationStatusDto} updateCalculationStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerUpdateSubmissionCalculationStatus: async (updateCalculationStatusDto: UpdateCalculationStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCalculationStatusDto' is not null or undefined
            assertParamExists('submissionsControllerUpdateSubmissionCalculationStatus', 'updateCalculationStatusDto', updateCalculationStatusDto)
            const localVarPath = `/api/submissions/update-submission-calculation-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCalculationStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmissionsApi - functional programming interface
 * @export
 */
export const SubmissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddDraftTableRowDto} addDraftTableRowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerAddDraftTableRow(addDraftTableRowDto: AddDraftTableRowDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerAddDraftTableRow(addDraftTableRowDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerAddDraftTableRow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {CreateSubmissionDto} createSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerCreateSubmission(formId: string, createSubmissionDto: CreateSubmissionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerCreateSubmission(formId, createSubmissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerCreateSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUpdateDraftDataDto} createUpdateDraftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerCreateUpdateDraftData(createUpdateDraftDataDto: CreateUpdateDraftDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerCreateUpdateDraftData(createUpdateDraftDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerCreateUpdateDraftData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUpdateDraftNoteDto} createUpdateDraftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerCreateUpdateDraftNote(createUpdateDraftNoteDto: CreateUpdateDraftNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerCreateUpdateDraftNote(createUpdateDraftNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerCreateUpdateDraftNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DraftDataDto} draftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerDeleteDraftData(draftDataDto: DraftDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerDeleteDraftData(draftDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerDeleteDraftData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteDraftTableRowDto} deleteDraftTableRowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerDeleteDraftTableRow(deleteDraftTableRowDto: DeleteDraftTableRowDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerDeleteDraftTableRow(deleteDraftTableRowDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerDeleteDraftTableRow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerGetFormDraftData(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerGetFormDraftData(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerGetFormDraftData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerGetFormDraftDataByQuestion(formId: string, questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerGetFormDraftDataByQuestion(formId, questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerGetFormDraftDataByQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerGetFormDraftNote(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerGetFormDraftNote(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerGetFormDraftNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerGetFormSectionSubmission(formId: string, sectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionSubmissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerGetFormSectionSubmission(formId, sectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerGetFormSectionSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerGetPreviousSubmissions(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormSubmissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerGetPreviousSubmissions(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerGetPreviousSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCalculationStatusDto} updateCalculationStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionsControllerUpdateSubmissionCalculationStatus(updateCalculationStatusDto: UpdateCalculationStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsControllerUpdateSubmissionCalculationStatus(updateCalculationStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionsApi.submissionsControllerUpdateSubmissionCalculationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubmissionsApi - factory interface
 * @export
 */
export const SubmissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {AddDraftTableRowDto} addDraftTableRowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerAddDraftTableRow(addDraftTableRowDto: AddDraftTableRowDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftDataDto>> {
            return localVarFp.submissionsControllerAddDraftTableRow(addDraftTableRowDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {CreateSubmissionDto} createSubmissionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateSubmission(formId: string, createSubmissionDto: CreateSubmissionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submissionsControllerCreateSubmission(formId, createSubmissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUpdateDraftDataDto} createUpdateDraftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateUpdateDraftData(createUpdateDraftDataDto: CreateUpdateDraftDataDto, options?: RawAxiosRequestConfig): AxiosPromise<DraftDataDto> {
            return localVarFp.submissionsControllerCreateUpdateDraftData(createUpdateDraftDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUpdateDraftNoteDto} createUpdateDraftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerCreateUpdateDraftNote(createUpdateDraftNoteDto: CreateUpdateDraftNoteDto, options?: RawAxiosRequestConfig): AxiosPromise<DraftNoteDto> {
            return localVarFp.submissionsControllerCreateUpdateDraftNote(createUpdateDraftNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DraftDataDto} draftDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerDeleteDraftData(draftDataDto: DraftDataDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.submissionsControllerDeleteDraftData(draftDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteDraftTableRowDto} deleteDraftTableRowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerDeleteDraftTableRow(deleteDraftTableRowDto: DeleteDraftTableRowDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.submissionsControllerDeleteDraftTableRow(deleteDraftTableRowDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormDraftData(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftDataDto>> {
            return localVarFp.submissionsControllerGetFormDraftData(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormDraftDataByQuestion(formId: string, questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftDataDto>> {
            return localVarFp.submissionsControllerGetFormDraftDataByQuestion(formId, questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormDraftNote(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftNoteDto>> {
            return localVarFp.submissionsControllerGetFormDraftNote(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetFormSectionSubmission(formId: string, sectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionSubmissionDto>> {
            return localVarFp.submissionsControllerGetFormSectionSubmission(formId, sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerGetPreviousSubmissions(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormSubmissionDto>> {
            return localVarFp.submissionsControllerGetPreviousSubmissions(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCalculationStatusDto} updateCalculationStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionsControllerUpdateSubmissionCalculationStatus(updateCalculationStatusDto: UpdateCalculationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.submissionsControllerUpdateSubmissionCalculationStatus(updateCalculationStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubmissionsApi - object-oriented interface
 * @export
 * @class SubmissionsApi
 * @extends {BaseAPI}
 */
export class SubmissionsApi extends BaseAPI {
    /**
     * 
     * @param {AddDraftTableRowDto} addDraftTableRowDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerAddDraftTableRow(addDraftTableRowDto: AddDraftTableRowDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerAddDraftTableRow(addDraftTableRowDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {CreateSubmissionDto} createSubmissionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerCreateSubmission(formId: string, createSubmissionDto: CreateSubmissionDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerCreateSubmission(formId, createSubmissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUpdateDraftDataDto} createUpdateDraftDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerCreateUpdateDraftData(createUpdateDraftDataDto: CreateUpdateDraftDataDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerCreateUpdateDraftData(createUpdateDraftDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUpdateDraftNoteDto} createUpdateDraftNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerCreateUpdateDraftNote(createUpdateDraftNoteDto: CreateUpdateDraftNoteDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerCreateUpdateDraftNote(createUpdateDraftNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DraftDataDto} draftDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerDeleteDraftData(draftDataDto: DraftDataDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerDeleteDraftData(draftDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteDraftTableRowDto} deleteDraftTableRowDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerDeleteDraftTableRow(deleteDraftTableRowDto: DeleteDraftTableRowDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerDeleteDraftTableRow(deleteDraftTableRowDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerGetFormDraftData(formId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerGetFormDraftData(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerGetFormDraftDataByQuestion(formId: string, questionId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerGetFormDraftDataByQuestion(formId, questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerGetFormDraftNote(formId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerGetFormDraftNote(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {string} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerGetFormSectionSubmission(formId: string, sectionId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerGetFormSectionSubmission(formId, sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerGetPreviousSubmissions(formId: string, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerGetPreviousSubmissions(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCalculationStatusDto} updateCalculationStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionsApi
     */
    public submissionsControllerUpdateSubmissionCalculationStatus(updateCalculationStatusDto: UpdateCalculationStatusDto, options?: RawAxiosRequestConfig) {
        return SubmissionsApiFp(this.configuration).submissionsControllerUpdateSubmissionCalculationStatus(updateCalculationStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}

